(function () {
  'use strict';

  // Variant select: keep the hidden variant id, price and button state in sync.
  document.querySelectorAll('[data-kit-buy]').forEach(function (buy) {
    var select = buy.querySelector('[data-kit-variant-select]');
    if (!select) return;

    var idInput = buy.querySelector('[data-kit-variant-id]');
    var priceEl = buy.querySelector('[data-kit-price]');
    var compareEl = buy.querySelector('[data-kit-compare]');
    var submit = buy.querySelector('[data-kit-submit]');
    var label = buy.querySelector('[data-kit-submit-label]');

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var available = option.getAttribute('data-available') === 'true';

      if (idInput) {
        idInput.value = option.value;
        idInput.disabled = !available;
      }
      if (priceEl) priceEl.textContent = option.getAttribute('data-price');
      if (compareEl) {
        var compare = option.getAttribute('data-compare');
        compareEl.textContent = compare || '';
        compareEl.hidden = !compare;
      }
      if (submit) submit.disabled = !available;
      if (label) {
        label.textContent = available
          ? buy.getAttribute('data-label-add')
          : buy.getAttribute('data-label-sold-out');
      }
    });
  });

  // Sticky purchase bar: shown once the hero buy box has scrolled out of view.
  var bar = document.querySelector('[data-kit-sticky]');
  var heroBuy = document.querySelector('[data-kit-hero-buy]');
  var finalCta = document.querySelector('[data-kit-final]');
  if (bar && heroBuy && 'IntersectionObserver' in window) {
    var heroGone = false;
    var finalSeen = false;
    var update = function () {
      var show = heroGone && !finalSeen;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (a) {
        a.tabIndex = show ? 0 : -1;
      });
    };
    new IntersectionObserver(function (entries) {
      heroGone = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      update();
    }).observe(heroBuy);
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        finalSeen = entries[0].isIntersecting;
        update();
      }).observe(finalCta);
    }
  }

  // Preview lightbox (native <dialog>).
  var dialog = document.querySelector('[data-kit-lightbox]');
  if (dialog && typeof dialog.showModal === 'function') {
    var dialogImg = dialog.querySelector('[data-kit-lightbox-img]');
    var dialogCaption = dialog.querySelector('[data-kit-lightbox-caption]');
    var lastTrigger = null;

    document.querySelectorAll('[data-kit-preview]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        lastTrigger = trigger;
        dialogImg.src = trigger.getAttribute('data-full');
        dialogImg.alt = trigger.getAttribute('data-alt') || '';
        dialogCaption.textContent = trigger.getAttribute('data-caption') || '';
        dialog.showModal();
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.hasAttribute('data-kit-lightbox-close')) dialog.close();
    });
    dialog.addEventListener('close', function () {
      dialogImg.removeAttribute('src');
      if (lastTrigger) lastTrigger.focus();
    });
  }
})();
